import { render, staticRenderFns } from "./newsHeader.vue?vue&type=template&id=b3927efe&scoped=true&"
import script from "./newsHeader.vue?vue&type=script&lang=js&"
export * from "./newsHeader.vue?vue&type=script&lang=js&"
import style0 from "./newsHeader.vue?vue&type=style&index=0&id=b3927efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3927efe",
  null
  
)

export default component.exports